(function() {
  if (window.__cmsLdPrideCardDrawerBound) return;
  window.__cmsLdPrideCardDrawerBound = true;

  function getCard(element) {
    return element && element.closest ? element.closest('.cms-ld-pride-card--has-drawer') : null;
  }

  function getEventElement(event) {
    var target = event && event.target;

    return target instanceof Element ? target : target && target.parentElement;
  }

  function getDrawer(card) {
    return card ? card.querySelector('[data-pride-card-drawer]') : null;
  }

  function getToggle(card) {
    return card ? card.querySelector('[data-pride-card-toggle]') : null;
  }

  function getVideo(card) {
    return card ? card.querySelector('[data-pride-card-video]') : null;
  }

  function playCardVideo(card) {
    var video = getVideo(card);

    if (!card || !video) return;

    if (video.hasAttribute('muted')) {
      video.muted = true;
    }

    video.controls = true;

    var playRequest = video.play();
    card.classList.add('is-video-playing');

    if (playRequest && typeof playRequest.catch === 'function') {
      playRequest.catch(function() {
        card.classList.remove('is-video-playing');
        video.controls = false;
      });
    }
  }

  function pauseCardVideo(card) {
    var video = getVideo(card);

    if (!card || !video) return;

    video.pause();
    video.controls = false;
    card.classList.remove('is-video-playing');
  }

  function closeCard(card) {
    var drawer = getDrawer(card);
    var toggle = getToggle(card);

    if (!card || !drawer || !toggle) return;

    card.classList.remove('is-open');
    drawer.hidden = true;
    toggle.setAttribute('aria-expanded', 'false');
  }

  function closeAllCards() {
    document.querySelectorAll('.cms-ld-pride-card--has-drawer.is-open').forEach(closeCard);
  }

  function openCard(card) {
    var drawer = getDrawer(card);
    var toggle = getToggle(card);

    if (!card || !drawer || !toggle) return;

    closeAllCards();
    card.classList.add('is-open');
    drawer.hidden = false;
    toggle.setAttribute('aria-expanded', 'true');
  }

  document.addEventListener('click', function(event) {
    var element = getEventElement(event);
    if (!element || !element.closest) return;

    var toggle = element.closest('[data-pride-card-toggle]');
    if (toggle) {
      var toggleCard = getCard(toggle);
      var isOpen = toggleCard && toggleCard.classList.contains('is-open');

      event.preventDefault();

      if (isOpen) {
        closeCard(toggleCard);
      } else {
        openCard(toggleCard);
      }
      return;
    }

    var closeButton = element.closest('[data-pride-card-close]');
    if (closeButton) {
      event.preventDefault();
      closeCard(getCard(closeButton));
      return;
    }

    var videoTrigger = element.closest('[data-pride-card-video-cover], [data-pride-card-video-play]');
    if (videoTrigger) {
      event.preventDefault();
      playCardVideo(videoTrigger.closest('.cms-ld-pride-card'));
      return;
    }

    if (element.closest('[data-pride-card-drawer]')) {
      return;
    }

    closeAllCards();
  });

  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape') {
      closeAllCards();
    }
  });

  document.addEventListener('mouseover', function(event) {
    var element = getEventElement(event);
    if (!element || !element.closest) return;

    var cover = element.closest('[data-pride-card-video-hover]');
    var card = cover ? cover.closest('.cms-ld-pride-card') : null;

    if (!cover || !card || card.classList.contains('is-video-playing')) return;
    if (cover.contains(event.relatedTarget)) return;

    playCardVideo(card);
  });

  document.addEventListener('mouseout', function(event) {
    var element = getEventElement(event);
    if (!element || !element.closest) return;

    var card = element.closest('.cms-ld-pride-card--video');

    if (!card || !card.querySelector('[data-pride-card-video-hover]')) return;
    if (card.contains(event.relatedTarget)) return;

    pauseCardVideo(card);
  });

  document.addEventListener('ended', function(event) {
    if (!event.target.matches('[data-pride-card-video]')) return;

    var card = event.target.closest('.cms-ld-pride-card');
    if (!card) return;

    event.target.controls = false;
    card.classList.remove('is-video-playing');
  }, true);
})();
